
$(document).ready(function () {
  searchToggle();
});

function searchToggle() {

  $(document)
    .find(".c-sidebar-menu__top")
    .on("click", function (e) {
      // Expand or collapse this panel and change font awesome icon
      if ($(this).hasClass("open")) {
        $(this).removeClass("open");
        $(".c-sidebar-menu__items").removeClass("open");
      } else {
        $(this).addClass("open");
        $(".c-sidebar-menu__items").addClass("open");
      }
    });
}
